//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiAccountMultipleOutline,
  mdiCogOutline,
  mdiPlusOutline,
  mdiFileOutline,
  mdiUpdate,
  mdiDeleteOutline,
  mdiHomeOutline,
  mdiAccountCircleOutline,
} from '@mdi/js'

export default {
  setup() {
    const admins = [
      ['Management', mdiAccountMultipleOutline],
      ['Settings', mdiCogOutline],
    ]

    const cruds = [
      ['Create', mdiPlusOutline],
      ['Read', mdiFileOutline],
      ['Update', mdiUpdate],
      ['Delete', mdiDeleteOutline],
    ]

    return {
      admins,
      cruds,
      mdiHomeOutline,
      mdiAccountCircleOutline,
    }
  },
}
